import { render, staticRenderFns } from "./AiCoding.vue?vue&type=template&id=1217f92a&scoped=true&"
import script from "./AiCoding.vue?vue&type=script&lang=js&"
export * from "./AiCoding.vue?vue&type=script&lang=js&"
import style0 from "./AiCoding.vue?vue&type=style&index=0&id=1217f92a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1217f92a",
  null
  
)

export default component.exports